import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_up",
  "use": "icon-arrow_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow_up\"><path d=\"M882.063 689.404l0.849-0.835-348.285-348.285c-12.496-12.496-32.758-12.496-45.254 0L141.088 688.57c27.837 27.836 72.796 28.114 100.975 0.835l0.849-0.835L512 419.479l269.088 269.09c27.837 27.836 72.796 28.114 100.975 0.835z\" fill=\"#000000\" fill-opacity=\".65\" p-id=\"22729\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow_up.svg
// module id = rR1b
// module chunks = 25